import { Button } from '@startuptools/ui/Button';
import { Card } from '@startuptools/ui/Card';
import { ErrorBoundary } from '@startuptools/ui/ErrorBoundary';
import { Skeleton } from '@startuptools/ui/Skeleton';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { useCompanySuspenseQuery } from '../../graphql/react-operations';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useNavigate } from '../Navigate';
import { Trans } from '@lingui/react';
import { StripeStatusChip } from '../../company/billing/StripeStatusChip';
import { Suspense } from 'react';
import { useCompanySubscriptionSuspenseQuery } from './CompanySubscription.graphql';
import { Link } from 'react-router-dom';

export const CompanySubscription = () => {
  const companyId = useCompanyId();
  const { link } = useNavigate();

  const {
    data: { companySubscription: sub },
  } = useCompanySubscriptionSuspenseQuery({ variables: { companyId }, fetchPolicy: 'cache-and-network' });

  if (!sub) {
    return (
      <>
        <Trans id="Free Plan" />
        <Button component={Link} to={link('/settings/billing')}>
          <Trans id="Upgrade Plan" />
        </Button>
      </>
    );
  }

  return (
    <>
      <Typography level="title-md">
        <Stack direction="row" gap={1} alignItems="center">
          <Trans
            id="Plan: {plan} <stripeStatusChip>{status}</stripeStatusChip>"
            values={{ plan: sub.mainProductName, status: sub.status }}
            components={{ stripeStatusChip: <StripeStatusChip /> }}
          />
        </Stack>
      </Typography>
      <Button variant="outlined" component={Link} to={link('/settings/billing')}>
        <Trans id="Handle Billing" />
      </Button>
    </>
  );
};

const CompanySubscriptionCardInner = () => {
  const companyId = useCompanyId();
  const {
    data: { company },
  } = useCompanySuspenseQuery({ variables: { id: companyId } });

  if (company.isDemo) {
    return null;
  }

  return (
    <Card variant="soft">
      <CompanySubscription />
    </Card>
  );
};

export const CompanySubscriptionCard = () => {
  return (
    <ErrorBoundary fallback={<></>}>
      <Suspense
        fallback={
          <Card variant="soft">
            <Stack gap={1}>
              <Skeleton variant="text" level="title-md" />
              <Skeleton variant="rectangular" height={36} />
            </Stack>
          </Card>
        }
      >
        <CompanySubscriptionCardInner />
      </Suspense>
    </ErrorBoundary>
  );
};
